import React, { useState, useEffect, useContext } from 'react'
import { useDispatch } from 'react-redux'
import { CCard, CCol, CButton, CRow } from '@coreui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle, faEdit } from '@fortawesome/free-solid-svg-icons'
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons'
import BannerModal from './BannerModal'
import { updateTemplate } from '../../../Redux/Actions/templateAction'
import { checkPermissions, getThumbnail, raiseToast } from '../../utils/helper'
import ReactDragListView from 'react-drag-listview/lib/index.js'
import DeleteModal from 'src/components/DeleteModal/DeleteModal'
import { dispatchAlert } from 'src/Redux/Actions/authAction'
import { GlobalContext } from '../../context/GlobalState'
import { PERMISSIONS } from 'src/views/utils/permissions'
import { isEmpty } from 'lodash'
import ImageNotFound from '../../../assets/image-not-found.jpg'
import { AppContext } from 'src/views/context/app'
import EditIconBlack from '../../../assets/banner-edit.svg'
import TrashIconDark from '../../../assets/banner-delete.svg'

const BannerHomePage = ({ data, templateConfig, homePageConfig, getTemplate }) => {
  const dispatch = useDispatch()
  const language = localStorage.getItem('language')
  const [banners, setBanners] = useState([...data])
  const [openModal, setOpenModal] = useState(false)
  const [showChange, setShowChange] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [selectedBanner, setSelectedBanner] = useState({})
  const [selectedIndex, setSelectedIndex] = useState('')

  const { userSessionObj } = useContext(GlobalContext)
  const { accountObj } = useContext(AppContext)

  const defaultLangCheck = language === accountObj?.default_language
  const createAllowed =
    checkPermissions(userSessionObj.session_data.permissions, PERMISSIONS.WEBSITE.CREATE) &&
    defaultLangCheck
  const updateAllowed =
    checkPermissions(userSessionObj.session_data.permissions, PERMISSIONS.WEBSITE.UPDATE) &&
    defaultLangCheck
  const deleteAllowed =
    checkPermissions(userSessionObj.session_data.permissions, PERMISSIONS.WEBSITE.DELETE) &&
    defaultLangCheck

  useEffect(() => {
    setBanners([...data])
  }, [data])

  const updateBanners = async (bannerData) => {
    let payload = {
      ...templateConfig,
      pages: {
        home_page: {
          ...homePageConfig,
          banners: bannerData,
        },
      },
    }

    let templateRes = await dispatch(updateTemplate(payload))

    if (templateRes?.success) {
      getTemplate()
      return true
    }
    return false
  }
  const bannerCallback = async (bannerObj) => {
    if (updateBanners([...data, bannerObj])) {
      setOpenModal(false)
    }
  }
  const saveReorder = async () => {
    if (updateBanners(banners)) {
      setShowChange(false)
    }
  }

  const bannerEdit = async (bannerObj) => {
    banners[selectedIndex] = bannerObj
    if (updateBanners(banners)) {
      setOpenModal(false)
    }
  }

  const handleBannerDelete = () => {
    banners.splice(selectedIndex, 1)
    if (updateBanners(banners)) {
      setDeleteModal(false)
      setSelectedIndex('')
    }
  }

  const onCancelReorder = () => {
    setBanners([...data])
    setShowChange(false)
  }

  const handleDelete = (index) => {
    if (!updateAllowed)
      return dispatch(dispatchAlert('danger', `Error`, `Insufficient Permissions!!`, true))
    setSelectedIndex(index)
    setDeleteModal(true)
  }

  const dragProps = {
    onDragEnd(fromIndex, toIndex) {
      if (!defaultLangCheck) {
        raiseToast('error', 'Reordering Allowed only on Default Language')
        return
      }
      setShowChange(true)
      const data = [...banners]
      const item = data.splice(fromIndex, 1)[0]
      data.splice(toIndex, 0, item)
      setBanners([...data])
    },
    nodeSelector: 'div',
    handleSelector: 'img',
  }

  return (
    <>
      <CCard style={{ minHeight: '37rem' }}>
        <CRow className="mt-5 mx-5">
          <CCol>
            <p className="h3">Banner Items</p>
          </CCol>
          <CCol>
            <div className="px-2 d-md-flex justify-content-md-end">
              <CButton
                className="text-white"
                color="info"
                onClick={() => {
                  setSelectedBanner({})
                  setOpenModal(true)
                }}
                disabled={!createAllowed}
                style={{ pointerEvents: 'auto' }}
                title={defaultLangCheck ? '' : 'Adding Banner Available on Default Language'}
              >
                <FontAwesomeIcon icon={faPlusCircle} className="mx-2" />
                Add Banner
              </CButton>
            </div>
          </CCol>
        </CRow>

        <div className=" mt-2 mx-5 logo-row scrollbar-horizontal">
          {!isEmpty(banners) ? (
            <ReactDragListView.DragColumn {...dragProps}>
              <div className="banner-div mt-3">
                {banners.map((item, index) => (
                  <div key={index} className="position-relative">
                    <img
                      src={getThumbnail(
                        userSessionObj.session_data.cf_domain_name,
                        item.image_s3_key,
                      )}
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null // prevents looping
                        currentTarget.src = ImageNotFound
                      }}
                      alt="movie"
                      className={''}
                    />

                    <div className="banner-abs-icons">
                      {updateAllowed && (
                        <img
                          src={EditIconBlack}
                          style={{
                            width: '1.2rem',
                            height: '1.2rem',
                            marginRight: `${deleteAllowed ? '' : '1rem'}`,
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            setSelectedIndex(index)
                            setSelectedBanner(item)
                            setOpenModal(true)
                          }}
                        />
                      )}

                      {deleteAllowed && (
                        <img
                          src={TrashIconDark}
                          style={{
                            width: '1.2rem',
                            height: '1.2rem',
                            cursor: 'pointer',
                            marginLeft: '0.5rem',
                          }}
                          onClick={() => handleDelete(index)}
                        />
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </ReactDragListView.DragColumn>
          ) : (
            <div className="d-flex justify-content-center">
              <p>No Banners Found</p>
            </div>
          )}
        </div>
        <div className="mx-5 d-flex justify-content-end">
          <p className="h5">
            {!isEmpty(banners) &&
              defaultLangCheck &&
              banners.length > 1 &&
              updateAllowed &&
              `* Drag the item to re-arrange`}
          </p>
        </div>
        <CRow className="mx-5 banner-row">
          {showChange && updateAllowed && (
            <div className="d-flex justify-content-end">
              <CButton className="text-white mx-3" color="info" onClick={onCancelReorder}>
                Cancel
              </CButton>
              <CButton className="text-white" color="info" onClick={saveReorder}>
                Save
              </CButton>
            </div>
          )}
        </CRow>
      </CCard>
      {openModal && (
        <BannerModal
          openModal={openModal}
          onCancel={() => {
            setOpenModal(false)
            setSelectedBanner({})
          }}
          editData={selectedBanner}
          updateCallback={bannerEdit}
          bannerCallback={bannerCallback}
        />
      )}
      {deleteModal && (
        <DeleteModal
          openModal={deleteModal}
          title={`Are you sure you want to Remove this Banner?`}
          confirmButtonText={`Yes`}
          onCancel={() => {
            setDeleteModal(false)
            setSelectedIndex('')
          }}
          onConfirm={handleBannerDelete}
        />
      )}
    </>
  )
}

export default BannerHomePage
